/* ================================================================ */
// MENU CONTAINER | Menu.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React from 'react';
import PropTypes from 'prop-types';
// Redux
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
// Actions
import { fetchStories } from '../../actions/Data/Content';
import { updateMapState } from '../../actions/Map';
// Selectors
import { getActivePanels, getLoadingStatus, getLoadingStatusSelector, getStoriesFlatMap } from '../../selectors/Data';
// Material UI
import makeStyles from '@material-ui/styles/makeStyles';
import Slide from '@material-ui/core/Slide';
// Library Components
import {MenuTypes} from '@myglobe/core/dist/types';
import Menu from './Menu';
import useReactRouter from 'use-react-router';
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(() => ({
    root: {

    },
    nav: {
        position: 'absolute',
        zIndex: 1,
        left: '100%',
        top: 'calc(100% - 16rem)',
        width: '38vw'
    }
}));
/* ========================================== */
/**
 * Dynamic Menu Container
 * ----------------------
 * Wrapper for redux state-driven menu populated
 * by provided index
 *
 * @param {object} props component props
 * @param {object} props.styles menu style overrides
 * @param {string} props.type menu layout type <tab|list|timeline>
 * @param {string} props.index menu index for selector
 * @param {string} props.icon default fallback icon
 * @param {string} props.routeParam route parameter to listen for
 */
const DynamicMenu = ({
    type,
    index,
    ...otherProps
}) => {
    const classes = useStyles();
    const {match} = useReactRouter();
    const slug = otherProps.routeParam ? match.params[otherProps.routeParam] : baseURL;
    const items = useSelector(
        state=>{
            let data = [];
            switch(index) {
            case 'panels':
                data = getActivePanels(state, slug) || [];
                break;
            case 'stories':
                data = getStoriesFlatMap(state) || [];
                return data.map(dataItem=>{
                    return {
                        title: dataItem.title,                        
                        icon: 'trip_origin',
                        slug: dataItem.slug,
                        path: `/${slug}`
                    };
                });
            default:
                data = getActivePanels(state, slug) || [];
            }
            return data.map(dataItem => {
                return {
                    title: dataItem.title,
                    icon: 'trip_origin',
                    slug: dataItem.slug,
                    path: `${slug}/${dataItem.slug}`
                };
            });
        }/*, (newItems, prevItems)=>newItems
            .filter(
                ({path})=>prevItems
                    .some(prevItem=>prevItem.path === path)
            ).length === 0*/
    );
    /* ======================== */
    // RENDER
    /* ======================== */
    return (
        <Slide key="panel-navigation-slide" direction="up" in={!otherProps.isLoading} timeout={{enter: 1000, exit: 200}} mountOnEnter unmountOnExit>
            <div key="panel-navigation" className={classes.nav}>
                <Menu type={type} {...otherProps} items={items} />
            </div>
        </Slide>
    );
};
/* ======================== */
// PROPS
/* ======================== */
DynamicMenu.propTypes = {
    screen: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired
    }),
    styles: PropTypes.object,
    type: PropTypes.oneOf(Object.values(MenuTypes)),
    index: PropTypes.string.isRequired,
    icon: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        icon: PropTypes.string,
        path: PropTypes.string.isRequired,
        styles: PropTypes.object,
        items: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string.isRequired,
            icon: PropTypes.string,
            path: PropTypes.string.isRequired,
            styles: PropTypes.object
        }))
    })),
    routeParam: PropTypes.string,
    /*,
    menuItems: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired
    }))*/
};
DynamicMenu.defaultProps = {
    styles: {},
    items: [],
    menuItems: []
};
/* ========================================== */
// Redux
/* ========================================== */
const mapStateToProps = (store, props) =>{
    const getLoading = getLoadingStatusSelector(['stories', 'globe', 'panels', 'states']);
    //const getMenu = getMenuItems(props.index, props.slug);
    //menuItems: getMenu(store)//getMenuItems(store, props.index, props.slug)
    return {
        isLoading: getLoading(store),
        isConfigLoading: getLoadingStatus(store, 'globe'),
    };
};
const mapDispatchToProps = dispatch => {
    return bindActionCreators(Object.assign({fetchStories, updateMapState, dispatch}), dispatch);
};
/* ========================================== */
// Export
/* ========================================== */
export default connect(mapStateToProps, mapDispatchToProps)(DynamicMenu);//(React.memo(Story, areEqual));